import React from "react";
import { Accordion, AccordionSummary, AccordionDetails, Typography } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const ReservationAccordion = ({ data, value, setValue, label, type, ModuleComponent }) => {
  return (
    <Accordion
      sx={{
        width: "100%",
        backgroundColor: "white", // Matches Select component
        boxShadow: "none", // Removes elevation
        border: "1px solid #ccc", // Light border like Select
        borderRadius: "8px", // Rounded corners
        padding: "8px", // Adds padding to match Select
        "&:before": { display: "none" }, // Removes default MUI Accordion line
        mb: 2,
      }}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls={`${type}-content`}
        id={`${type}-header`}
      >
        <Typography variant="subtitle1" fontWeight={600}>
          {label}
        </Typography>
      </AccordionSummary>
      <AccordionDetails>
        <ModuleComponent data={data} value={value} setValue={setValue} label={label} type={type} />
      </AccordionDetails>
    </Accordion>
  );
};

export default ReservationAccordion;

